import type { SVGProps } from "react";
export interface BracketRoundEllipsisVrIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BracketRoundEllipsisVrIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BracketRoundEllipsisVrIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12c0-4.102 2.037-7.728 5.15-9.92l.099-.061a1.126 1.126 0 0 1 1.198 1.9l-.466.35A9.86 9.86 0 0 0 3.125 12c0 3.13 1.456 5.92 3.731 7.731l.466.349.09.072a1.125 1.125 0 0 1-1.288 1.83l-.099-.062-.57-.428A12.1 12.1 0 0 1 .876 12Zm20 0a9.86 9.86 0 0 0-4.197-8.08l.649-.92.647-.92a12.11 12.11 0 0 1 5.15 9.92c0 4.102-2.037 7.727-5.15 9.92a1.125 1.125 0 0 1-1.296-1.84A9.86 9.86 0 0 0 20.875 12m-4.468-9.648a1.125 1.125 0 0 1 1.567-.272l-1.296 1.84a1.125 1.125 0 0 1-.271-1.567ZM11.5 16.129a.62.62 0 0 0-.124.37l.011.127a.6.6 0 0 0 .113.244zm1 .741a.6.6 0 0 0 .112-.245l.013-.125-.013-.127a.6.6 0 0 0-.111-.244zm-1-5.241a.62.62 0 0 0-.124.37l.011.127a.6.6 0 0 0 .113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126a.6.6 0 0 0-.111-.244zm-.334-6.486a1.625 1.625 0 1 1-1.782 1.782l-.009-.167.009-.165a1.625 1.625 0 0 1 1.615-1.459zM11.63 8a.62.62 0 0 0 .743 0zM12 6.875a.62.62 0 0 0-.37.125H12zM12 7h.373a.6.6 0 0 0-.246-.113L12 6.875zm1.627 9.5a1.625 1.625 0 0 1-3.242.167l-.009-.168.009-.165A1.625 1.625 0 0 1 12 14.875l.167.009c.82.083 1.46.774 1.46 1.616m0-4.5a1.625 1.625 0 0 1-3.242.167l-.009-.168.009-.165A1.625 1.625 0 0 1 12 10.375l.167.009c.82.083 1.46.774 1.46 1.615Z"
      />
    </svg>
  );
}
